import React, { useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';

// Plain number formatter (NO currency, NO INR) - moved outside to prevent recreation
const formatNumber = (value) => {
  if (value === null || value === undefined) return '0';
  const numericValue = Number(value) || 0;
  return numericValue.toLocaleString(); // change locale if you want
};

const formatBalancedown = (value) => {
  const numericValue = Number(value) || 0;
  if (numericValue < 0) {
    return <span className="text-[#f43]">{`${numericValue.toLocaleString()}`}</span>;
  }
  return <span className="text-[#3cd247]">{Math.abs(numericValue).toLocaleString()}</span>;
};

const formatBalanceUpline = (value) => {
  const numericValue = Number(value) || 0;
  if (numericValue >= 0) {
    return <span className="text-[#3cd247]">{numericValue.toLocaleString()}</span>;
  }
  return <span className="text-[#f43]">{numericValue.toLocaleString()}</span>;
};

const UpperTab = React.memo(() => {
  // Select only the specific fields we need to prevent unnecessary re-renders
  const userData = useSelector((state) => ({
    downlineBalance: state.auth?.user?.downlineBalance,
    downlineExposure: state.auth?.user?.downlineExposure,
    total_exposure: state.auth?.user?.total_exposure,
    credit: state.auth?.user?.credit,
    walletCredit: state.auth?.user?.wallet?.credit,
    balanceUpline: state.auth?.user?.balanceUpline,
  }), (prev, next) => {
    // Custom equality check - only re-render if these specific values change
    return (
      prev.downlineBalance === next.downlineBalance &&
      prev.downlineExposure === next.downlineExposure &&
      prev.total_exposure === next.total_exposure &&
      prev.credit === next.credit &&
      prev.walletCredit === next.walletCredit &&
      prev.balanceUpline === next.balanceUpline
    );
  });

  // Memoize computed values
  const credit = useMemo(() => {
    return userData.credit ?? userData.walletCredit;
  }, [userData.credit, userData.walletCredit]);

  const exposure = useMemo(() => {
    return userData.total_exposure;
  }, [userData.total_exposure]);

  const handleRefresh = useCallback(() => {
    console.log("Refresh clicked");
    // Add refresh logic here if needed
    window.location.reload();
  }, []);

  return (
    <div style={{ padding: '5px 20px' }} className="bg-[#171b36] text-white shadow-md">
      <div className="flex justify-between items-center">
        
        {/* Left Side */}
        <div className="flex flex-wrap items-center gap-6 ml-8">

          <div className="text-[14px] font-bold ">
            Balance Down:{' '}
{formatBalancedown(userData?.downlineBalance)}
          </div>

          <div className="text-[14px] font-bold">
            Balance Up:{' '}
{formatBalanceUpline(userData?.balanceUpline)}
          </div>

          <div className="text-[14px] font-bold">
            Net Exposure:{' '}
            <span className="text-[#3cd247]">
              {formatNumber(Math.abs(exposure || 0))}
            </span>
          </div>

          <div className="text-[14px] font-bold">
            Available Credit:{' '}
            <span className="text-white">
              {formatNumber(credit)}
            </span>
          </div>

        </div>

        {/* Right Side */}
        <button
          style={{ marginRight: '20px' }}
          onClick={handleRefresh}
          className="bg-[#11374a] hover:bg-[#1a4f66] text-white text-[14px] font-medium px-2 py-1 transition-colors"
        >
          Refresh
        </button>

      </div>
    </div>
  );
});

UpperTab.displayName = 'UpperTab';

export default UpperTab;
